/* ty-eilat-out-explain.js
 * קוביית אילת שאזלה נפתחת ומציגה מה זמין באילת. הכרעת יובל 17.09.2026, e3a.
 * המרקאפ, כולל role, tabindex ו-aria-expanded, מרונדר בשרת: snippets/ty-branch-stock.liquid.
 * הכלי וההסבר: shopify-agent/scripts/apply-eilat-out-explain-2026-09-17.mjs
 *
 * 🔴 כל המאזינים על document או window. product-info.js מחליף את תוכן #ty-branch-<section>
 *    בכל החלפת גרסה, ומאזין על אלמנט בתוכו מת ברינדור. אחרי הרינדור התיבה חוזרת סגורה.
 */
(function () {
  'use strict';
  if (window.__tyEilatOut) return;
  window.__tyEilatOut = true;

  function panelOf(cube) {
    var id = cube.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function cubeOf(panel) {
    return panel && panel.id ? document.querySelector('[data-tyeo-cube][aria-controls="' + panel.id + '"]') : null;
  }

  /* התיבה יושבת על תחתית הקובייה. השוליים מתמזגים עם שולי .tybp, ולכן מתקנים עד שהפער מתאפס */
  function attach(cube, panel) {
    for (var i = 0; i < 4; i++) {
      var gap = panel.getBoundingClientRect().top - cube.getBoundingClientRect().bottom;
      if (Math.abs(gap) < 0.5) break;
      panel.style.marginTop = (parseFloat(getComputedStyle(panel).marginTop) - gap) + 'px';
    }
  }

  function open(cube) {
    var panel = panelOf(cube);
    if (!panel) return;
    panel.hidden = false;
    cube.setAttribute('aria-expanded', 'true');
    attach(cube, panel);
  }

  function close(cube, focusCube) {
    var panel = panelOf(cube);
    if (panel) panel.hidden = true;
    cube.setAttribute('aria-expanded', 'false');
    if (focusCube) cube.focus();
  }

  function toggle(cube) {
    if (cube.getAttribute('aria-expanded') === 'true') close(cube, false);
    else open(cube);
  }

  /* לחיצה על גרסה: מסמנים את האפשרויות בבורר הווריאנטים ושולחים change אחד, בדיוק כמו
   * לחיצה של לקוח. הסניף עובר לאילת אחרי הרינדור, דרך window.__tyBranchSel שב-buy-buttons.liquid. */
  function pick(chip) {
    var panel = chip.closest('.tyeo');
    var cube = cubeOf(panel);
    var names = null, opts = null;
    try { names = JSON.parse(panel.getAttribute('data-tyeo-names')); } catch (e) { names = null; }
    try { opts = JSON.parse(chip.getAttribute('data-tyeo-opts')); } catch (e) { opts = null; }
    var vid = chip.getAttribute('data-tyeo-variant');
    var info = (cube && cube.closest('product-info')) || document.querySelector('product-info');
    var vs = info && info.querySelector('variant-selects');
    var inputs = [];
    var ok = !!(vs && names && opts && names.length === opts.length);
    if (ok) {
      var radios = Array.prototype.slice.call(vs.querySelectorAll('input[type="radio"]'));
      names.forEach(function (n, i) {
        var el = radios.filter(function (x) { return x.name.indexOf(n + '-') === 0 && x.value === opts[i]; })[0];
        if (el) inputs.push(el); else ok = false;
      });
    }
    if (!ok) {
      window.__tyBranchSel = 'eilat';
      window.location.href = window.location.pathname + '?variant=' + encodeURIComponent(vid);
      return;
    }
    var wrap = cube && cube.closest('[id^="ty-branch-"]');
    if (cube) close(cube, false);
    /* ממתינים תור אחד, כדי שכל מאזין על שינויי העוטף יסיים לפני שקובעים את הסניף */
    setTimeout(function () {
      window.__tyBranchSel = 'eilat';
      if (wrap && window.MutationObserver) {
        var mo = new MutationObserver(function () {
          var link = wrap.querySelector('[data-ty-pick="eilat"]');
          if (link) { mo.disconnect(); setTimeout(function () { link.focus({ preventScroll: true }); }, 60); }
        });
        mo.observe(wrap, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 10000);
      }
      var changed = inputs.filter(function (x) { return !x.checked; });
      inputs.forEach(function (x) { x.checked = true; });
      var target = changed.length ? changed[changed.length - 1] : inputs[inputs.length - 1];
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var chip = t.closest('[data-tyeo-chip]');
    if (chip) { ev.preventDefault(); pick(chip); return; }
    var cube = t.closest('[data-tyeo-cube]');
    if (cube) { ev.preventDefault(); toggle(cube); }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var cube = ev.target && ev.target.closest && ev.target.closest('[data-tyeo-cube]');
    if (!cube) return;
    ev.preventDefault();
    toggle(cube);
  });

  /* Escape בשלב הלכידה. ווידג'ט הנגישות מאזין ל-Escape בכל הדף ומעביר את הפוקוס לכפתור שלו
   * (נמדד 17.09.2026, גם בחי). כשהתיבה פתוחה ה-Escape שייך לה: סוגרים ומחזירים פוקוס לקובייה. */
  var swallowUntil = 0;
  window.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var cube = document.querySelector('[data-tyeo-cube][aria-expanded="true"]');
    if (!cube) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    swallowUntil = Date.now() + 1000;
    close(cube, true);
  }, true);
  window.addEventListener('keyup', function (ev) {
    if (ev.key !== 'Escape' || Date.now() > swallowUntil) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
  }, true);
})();
